import React from "react";
import { Outlet, NavLink, Link } from "react-router-dom";
import Logo from "../../../assets/logo.jpg";

const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Doctor", path: "/login/doctor-lab" }, // single combined link
  { label: "Lab", path: "/login/doctor-lab" }, // single combined link
];

export default function WebsiteLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className="bg-white border-b border-slate-100 sticky top-0 z-20">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={Logo}
              alt="Docjee - Har Sehat Ka Saathi"
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Nav links */}
          <div className="hidden md:flex items-center gap-8 text-sm font-medium">
            {NAV_LINKS.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `transition-colors ${
                    isActive
                      ? "text-emerald-600 font-semibold"
                      : "text-slate-600 hover:text-slate-900"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          {/* Auth actions */}
          <div className="flex items-center gap-3">
            <Link
              to="/register/patient"
              className="rounded-full bg-emerald-600 px-5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-700"
            >
              Sign Up
            </Link>
            <Link
              to="/login/patient"
              className="rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Sign In
            </Link>
          </div>
        </div>
      </nav>

      {/* Page Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 text-sm py-8 mt-auto">
        <div className="max-w-6xl mx-auto px-6 flex flex-wrap gap-4 items-center justify-between">
          {/* Footer Logo Container */}
          <Link to="/" className="flex items-center bg-white px-3 py-1.5 rounded-xl shadow-sm">
            <img
              src={Logo}
              alt="iDocjee"
              className="h-10 w-auto object-contain"
            />
          </Link>
          
          <div className="flex gap-6">
            <Link to="/policies" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/faq" className="hover:text-white transition-colors">
              FAQ
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors">
              Contact
            </Link>
          </div>
          <p>© {new Date().getFullYear()} Docjee. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
